<template>
  <div class="main-page page-map" :style="{ background: isXiaodu && `url('https://qiniu.terminal.laway.cn/bg-img.png')` }">
    <Menus :title="mapname" :home="true" />
    <div class="map-wrap container-flex" :style="{ 'margin-top': isXiaodu && '120px' }">
      <div class="map-area-list" :style="{ height: isXiaodu && '85vh' }">
        <div class="service-content">
          <div class="choose-item">
            <div class="content-block-title">请选择您要查询的地点</div>
            <div class="option-area-select">
              <a class="btn btn-default btn-lg" @click="setArea(codearea)" :class="{ 'btn-primary': code == codearea }">
                <span>全部</span>
              </a>
              <a class="btn btn-default btn-lg" v-for="(item, key) in residence" :key="'key-' + key" @click="setArea(key)" :class="{ 'btn-primary': code == key }">
                <span>{{ item.alias }}</span>
              </a>
              <a class="btn btn-default btn-lg" @click="show_select_areacode = true">
                <span>其他州市</span>
              </a>
            </div>
            <div v-if="org_type == 2">
              <div class="content-block-title">请选择您要查询的类别</div>
              <div class="option-area-select">
                <a class="btn btn-default btn-lg" v-for="(item, key) in disputeList" :key="'key-' + key" @click="setType(key)" :class="{ 'btn-primary': dispute == key }">
                  <span>{{ item }}</span>
                </a>
              </div>
            </div>
            <div class="content-block-title" v-if="masData.length">输入名称关键字可以快速搜索</div>
            <div class="search-content" v-if="masData.length">
              <input type="text" class="form-control input-lg" placeholder="请输入名称关键字" v-model="searchinfo" />
            </div>
            <div v-else class="tips">暂无数据</div>
            <div class="list-block">
              <ul v-if="dispute === '0' && !search_flag">
                <li v-for="(item, index) in masData" :key="'key-' + index">
                  <a href="javascript:void(0)" @click="getToPoint(index)" class="item-link item-content" :class="{ on: selected == index }">
                    <div class="item-inner">
                      <div class="item-title">
                        <div class="ht">
                          <span>{{ index + 1 }}</span>
                          <strong>{{ item.name | getOrgName }}</strong>
                        </div>
                        <p>
                          地址：{{ item.address }}
                          <br />
                          <span>电话：{{ item.tell ||'暂无'}}</span>
                          <template v-if="org_type==10">
                            <br />
                            <span>行政复议机构：{{item.field3}}</span>
                            <br />
                            <span>邮政编码：{{item.zipcode}}</span>
                          </template>
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul v-else-if="dispute && !search_flag">
                <li v-for="(item, index) in masData_dispute" :key="'key-' + index">
                  <a href="javascript:void(0)" @click="getToPoint(index)" class="item-link item-content" :class="{ on: selected == index }">
                    <div class="item-inner">
                      <div class="item-title">
                        <div class="ht">
                          <span>{{ index + 1 }}</span>
                          <strong>{{ item.name }}</strong>
                        </div>
                        <p>
                          地址：{{ item.address }}
                          <br />
                          <span>电话：{{ item.tell ||'暂无'}}</span>
                          <template v-if="org_type==10">
                            <br />
                            <span>行政复议机构：{{item.field3}}</span>
                            <br />
                            <span>邮政编码：{{item.zipcode}}</span>
                          </template>
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul v-else-if="search_flag">
                <li v-for="(item, index) in masData_search" :key="'key-' + index">
                  <a href="javascript:void(0)" @click="getToPoint(index)" class="item-link item-content" :class="{ on: selected == index }">
                    <div class="item-inner">
                      <div class="item-title">
                        <div class="ht">
                          <span>{{ index + 1 }}</span>
                          <strong>{{ item.name }}</strong>
                        </div>
                        <p>
                          地址：{{ item.address }}
                          <br />
                          <span>电话：{{ item.tell ||'暂无'}}</span>
                          <template v-if="org_type==10">
                            <br />
                            <span>行政复议机构：{{item.field3}}</span>
                            <br />
                            <span>邮政编码：{{item.zipcode}}</span>
                          </template>
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
              <p v-if="no_result" class="warning_tips">没有在{{ county_name }}搜索到该{{ mapname }}</p>
              <!-- <p v-if="no_search"
              class="warning_tips">没有在云南省搜索到该{{mapname}}</p>-->
            </div>
          </div>
        </div>
      </div>
      <div class="map-container-panel">
        <div id="map-container" :style="{ height: isXiaodu && '85vh' }"></div>
        <div class="map-empty" v-if="showempty">该机构暂无坐标信息！</div>
      </div>
    </div>
    <div class="select_area" v-if="show_select_area">
      <div class="wrap">
        <div class="ht">请选择您所在区域</div>
        <div class="content" v-if="key !== '530100'">
          <a v-for="(item, key) in residence" :key="'key-' + key" @click="setArea(key)">
            <span>{{ item }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="select_area" v-if="show_select_areacode">
      <div class="wrap">
        <div class="ht">请选择地区</div>
        <div class="content">
          <a v-for="(item, key) in $store.state.device.area" :key="'key-' + key" @click="setArea(key, true)">
            <span>{{ item.name }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="people-panel" v-if="showPeople" @click="showPeople=false">
      <div class="people-content" @click.stop>
        <div class="people-list">
          <div class="hts">{{mapname}}人员</div>
          <div class="flex flex-wrap p-item-panel">
            <div class="p-item" @click="currentstaff = v;showStaff=true" v-for="(v,index) in staffList" :key="'keys'+index">{{ v.name }}</div>
          </div>
        </div>

        <img src="https://qiniu.laway.cn/yn/2020/11/10/e823e0e822f711eb8cd1b4055d0b07be.png" alt="" class="people__close" @click="showPeople=false">
      </div>

    </div>
    <org-people :currentstaff="currentstaff" :orgtype="org_type" :showStaff="showStaff" @close="showStaff = false" />

  </div>
</template>
<script>
import OrgPeople from '@/components/org-people-dialog.vue'

import { orgTypeName, residence, disputeList } from '../../datas/js/config.js'
import Menus from '../../components/Menu.vue'
import { TMap } from '../../datas/js/common.js'
import { STAMAPLIST } from '../../datas/constants/statistics.js'

export default {
  data () {
    return {
      selected: '',
      residence: '',
      disputeList,
      searchinfo: '',
      search_flag: false,
      name: '',
      org_type: 1,
      isXiaodu: localStorage.getItem('xiaodu') || false,
      code: '',
      codearea: '',
      dispute: 0,
      show_select_area: false,
      show_select_areacode: false,
      userLocation: '',
      map_id: '',
      qq: '',
      map: '',
      markers_array: [],
      zoom: 16,
      map_center: [25.033481, 102.710082],
      masData: [],
      masData_dispute: [],
      masData_search: [],
      infoWin: '',
      alert: {
        show: false,
        info: ''
      },
      county_name: '',
      areaselect: {
        show: false,
        showchild: false
      },
      showempty: false,
      staffList: [],
      currentstaff: '',
      showStaff: false,
      showPeople: false
    }
  },
  computed: {
    codename () {
      return residence[this.code]
    },
    mapname () {
      return orgTypeName[this.org_type]
    },
    no_result () { //eslint-disable-line
      if (!this.search_flag && this.masData_search.length === 0) {
        return false
      } else if (this.code === 530100 && this.masData_search.length === 0) {
        this.county_name = '云南' //eslint-disable-line
        return true
      } else if (this.code !== '530100' && this.masData_search.length === 0) {
        this.county_name = this.residence[this.code].name //eslint-disable-line
        return true
      }
    },
    sortflag () {
      let flag = false
      if (this.$route.query.sort === 'distance') {
        flag = true
      }
      return flag
    }
  },
  async mounted () {
    window.mapPreviewStaff = this.mapPreviewStaff; // 将 previewStaff 方法绑定到 window

    const { area, config, point } = this.$store.state.device
    let currCode = config.web_code
    this.residence = area[currCode].children
    this.map_center = point.geography.split(',')
    const orgType = this.$route.params.org_type
    this.$root.getStatistics(`MAP_${STAMAPLIST[orgType]}`)
    this.org_type = orgType
    this.setArea(config.web_code, true)
  },
  methods: {
    chooseArea (value) {
      console.log(value)
    },
    async setArea (key, is_web_code = false) { //eslint-disable-line
      this.code = key
      console.log(key)
      this.show_select_area = false
      this.show_select_areacode = false
      if (is_web_code) {  //eslint-disable-line
        this.codearea = key
        this.residence = this.$store.state.device.area[key].children
        const n = Object.keys(this.residence)
        this.code = ['9', '10'].includes(this.org_type) ? key : parseInt(n[0])
      }
      this.init(this.org_type, this.code)
      this.setType('0')
      this.search_flag = false
      this.searchinfo = ''
    },
    setType (key) {
      this.search_flag = false
      this.searchinfo = ''
      this.dispute = key
      if (this.dispute === 0) {
        return
      }
      this.masData_dispute.length = 0
      for (var i = 0; i < this.masData.length; i++) {
        if (
          this.masData[i].dispute &&
          this.masData[i].dispute.toString() === key
        ) {
          let newitem = this.masData[i]
          newitem.index = i
          this.masData_dispute.push(newitem)
        }
      }
      this.show_select_area = false
    },
    // 跳到地图点，并显示改点信息
    getToPoint (index) {
      if (!this.masData.length) return
      const item = this.masData[index]
      if (!item.geography) {
        this.selected = index
        this.showempty = true
        return
      } else {
        this.showempty = false
      }
      const [lan, lng] = item.geography.split(',')
      const position = new this.qq.maps.LatLng(lan, lng)
      this.selected = index
      this.infoWin.open()
      this.infoWin.setContent(this.setMapContent(item))
      this.infoWin.setPosition(position)
      this.map.panTo(position)
    },
    // 设置地图点信息模版
    setMapContent (item) {
      let { name, address, tell } = item
      if (!tell) {
        tell = '暂无'
      }

      let str = name.split('/')
      str = str.length > 1 ? str[1] : str[0]
      const desc =
        this.org_type && item.desc
          ? `<strong>${this.org_type === '1' ? '专业' : '简介'}：</strong>${item.desc}` + '<br>'
          : ''
      const jdstatus = this.org_type === '1' ? `<div ><strong>状态：</strong>${item.field2}</div>` : ''
      const previewBtn = ['1', '2'].includes(this.org_type)
        ? `<div><strong>机构人员：</strong><a style="display: inline-block; background: #5168b6; color: #fff; padding: 3px 10px;border-radius: 6px;margin-top: 5px;" href="javascript:;" onclick="window.mapPreviewStaff('${String(item.id)}')" >查看机构人员</a></div>`
        : ''
      const xzfytxt = this.org_type === '10' ? `<div><strong>行政复议机构：</strong>${item.field3}<br><strong>邮政编码：</strong>${item.zipcode}<br></div>` : ''

      return `<div class="map-marker-info" style="padding:0 0 10px;">
          <h2 style="font-size:18px; margin:0 0 10px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">${str}</h2>
          <div style="color:#808080; font-size:16px;">
            ${desc}
            ${jdstatus}
            <strong  style="color:#808080; font-size:16px;">地址：</strong>${address} <br>
            <strong  style="color:#808080; font-size:16px;">电话：</strong>${tell}
             ${previewBtn}
             ${xzfytxt}
          </div>
        </div>`
    },
    // 初始化地图点
    async init (orgType, code) {
      // 获取api
      const { status, result, msg } = await this.$get(
        `https://yn.12348.laway.cn/pufa/api/organization/?org_type=${orgType}&code=${code}`,
        this
      )

      if (!status) {
        console.log('err:' + msg)
        return
      }
      const items = result.data

      // 设置地图
      const dom = document.querySelector('#map-container')
      if (dom.childNodes.length) {
        dom.childNodes[0].remove()
      }
      // 在此完成该函数
      const qq = await TMap(this.$root.webConfig.mapkey)
      items.map((v, i) => {
        if (v.geography_type === 1) {
          if (v.geography) {
            let [lat, lng] = v.geography.split(',')
            qq.maps.convertor.translate(new qq.maps.LatLng(lat, lng), 3, res => {
              const latlng = res[0]
              v.geography = latlng.lat + ',' + latlng.lng
            })
          }
        }
      })
      const map = new qq.maps.Map(dom, {
        center: new qq.maps.LatLng(...this.map_center),
        zoom: this.zoom
      })
      // 地图点信息
      const infoWin = new qq.maps.InfoWindow({ map, zIndex: 10000 })
      // 存储地图对象
      this.qq = qq
      this.map = map
      this.infoWin = infoWin
      // 是否获取用户信息，获取了则计算距离

      this.masData = this.getDistanceList(items)
      console.log(this.masData, 'this.masData')
      // 跳到的一个地图点中心，并打开信息
      this.getToPoint(0)
      const masData = this.masData
      this.markers_array = []
      if (!items.length) {
        this.masData = []
        this.markers_array = []
        return
      }
      for (let i = 0; i < masData.length; i++) {
        const geography = masData[i].geography || this.$store.state.device.point.geography
        const [lan, lng] = geography.split(',')
        const position = new qq.maps.LatLng(lan, lng)
        const anchor = new qq.maps.Point(24, 50)
        const size = new qq.maps.Size(100, 100)
        const origin = new qq.maps.Point(0, 0)
        const scaleSize = new qq.maps.Size(48, 48)
        const icon = new qq.maps.MarkerImage(
          '/img/ui/position.png',
          size,
          origin,
          anchor,
          scaleSize
        )
        // 添加marker
        const marker = new qq.maps.Marker({
          position,
          map,
          animation: qq.maps.MarkerAnimation.DOWN
        })
        const infotmp = this.setMapContent(masData[i])
        // 加载marker图标
        marker.setIcon(icon)
        this.markers_array.push(marker)
        // 添加点击事件
        qq.maps.event.addListener(marker, 'click', () => {
          infoWin.open()
          infoWin.setContent(infotmp)
          infoWin.setPosition(position)
        })
      }
    },
    getDistanceSortList (arr) {
      return arr.sort((a, b) => {
        const key = this.sortflag ? 'distance' : 'code'
        return a[key] - b[key]
      })
    },
    // 距离列表排讯
    getComputeList (arr) {
      let masdata = []
      this.getDistanceSortList(arr)
      arr.map(v => {
        let d = ''
        if (v.distance !== null) {
          d = v.distance > 1000
            ? `（距离${(v.distance / 1000).toFixed(2)}公里）`
            : `（距离${parseInt(v.distance.toFixed(2))}米）`
        }
        v.address += d
        masdata.push(v)
      })
      return masdata
    },
    // 计算距离列表
    getDistanceList (list) {
      const arr = []
      const [lat, lng] = this.map_center
      const qq = this.qq
      list.map((v, i) => {
        if (v.geography) {
          let p = v.geography.split(',')
          let d = qq.maps.geometry.spherical.computeDistanceBetween(
            new qq.maps.LatLng(lat, lng),
            new qq.maps.LatLng(p[0], p[1])
          )
          v.distance = d
        } else {
          v.distance = null
        }
        arr.push(v)
      })
      return this.getComputeList(arr)
    },
    async getSearchedInfo () {
      if (this.searchinfo.length > 0) {
        let reg = /[\u4e00-\u9fa5]/
        let info = this.searchinfo
        for (let char of this.searchinfo) {
          if (!reg.test(char)) { // 如果不是汉字
            info = info.replace(char, '')
            this.searchinfo = this.searchinfo.replace(char, '')
          }
        }
        if (info.length === 0) {
          this.search_flag = false
          return
        }
        this.search_flag = true
        this.masData_search.length = 0
        if (this.dispute === '0') {
          for (let i = 0; i < this.masData.length; i++) {
            if (this.masData[i].name.includes(info)) {
              let newitem = this.masData[i]
              newitem.index = i
              this.masData_search.push(newitem)
            }
          }
        } else {
          for (let i = 0; i < this.masData_dispute.length; i++) {
            if (this.masData_dispute[i].name.includes(info)) {
              let newitem = this.masData_dispute[i]
              this.masData_search.push(newitem)
            }
          }
          if (this.masData_search.length) {
            this.getToPoint(0)
          }
        }
      } else {
        this.search_flag = false
        this.getToPoint(0)
      }
    },
    filteredTell (tell) {
      if (!tell) {
        return '暂无'
      }
      if (tell.includes(';')) {
        return tell.split(';')[0]
      } else if (tell.includes('')) {
        return tell.split(' ')[0]
      }
    },
    mapPreviewStaff (id) {
      this.getOrgPeople(id)
    },
    async getOrgPeople (id) {
      let { items, status } = await this.$api.getOrganizationEmployee({ org_id: id }, false)
      if (!status) return
      this.staffList = items
      this.showPeople = true
    }

  },
  filters: {
    typename (org_type) { //eslint-disable-line
      return orgTypeName[org_type] //eslint-disable-line
    },
    getOrgName (val) {
      let str = val.split('/')
      return str.length > 1 ? str[1] : str[0]
    }
  },
  watch: {
    searchinfo () {
      this.searchinfo = this.searchinfo.replace(' ', '')
      this.getSearchedInfo()
    }
  },
  components: {
    Menus, OrgPeople
  },

}
</script>
<style lang="stylus" scoped>
.page-map
  .map-wrap
    display flex
    .map-area-list
      background #fff
      width 30%
      overflow-y scroll
      box-shadow 0.1rem 0 0.1rem rgba(0, 0, 0, 0.1)
      position relative
      z-index 100
    .service-content
      background #fff
      position relative
      .choose-service
        div.ht
          padding-top 1rem
          padding-bottom 0.1rem
          border-bottom 1px solid #ccc
          color #999
          margin-bottom 0.15rem
          font-size 0.16rem
        a
          margin-bottom 0.1rem
      .choose-item
        padding-top 0.1rem
        .content-block-title
          padding 0.15rem
          font-size 0.16rem
        .search-content
          padding 0 0.15rem 0.15rem
        .option-area-select
          padding 0 0 0.15rem 0.15rem
          a.btn
            margin 0 0.1rem 0.1rem 0
        .reback
          position fixed
          left 0
          top 0
          width 2.6rem
          a
            display inline-block
            padding 0.2rem
        .list-block
          margin 0 0 0.75rem
          ul
            padding 0
            list-style none
          .item-content
            display block
            border-top 1px solid #ddd !important
            &.on
              background #eee
            &:active
              background #eee
          .item-inner
            padding 0.15rem
          .item-title
            white-space normal
            .ht
              font-weight normal
              display block
              padding-bottom 0.05rem
              display flex
              align-items center
              span
                width 0.36rem
                height 0.43rem
                line-height 0.36rem
                display block
                margin-right 0.05rem
                background-image url('/img/ui/map.png')
                background-size 0.36rem 0.43rem
                text-align center
                color #fff
                font-size 0.18rem
                flex-shrink 0
              strong
                width auto
                font-size 0.18rem
            p
              color #999
              margin 0
              font-size 0.16rem
          .warning_tips
            padding-left 20px
            font-size 16px
            color red
        .tips
          margin 0 0.15rem
          padding-top 0.15rem
          border-top 1px dashed #ccc
          font-size 0.18rem
          color #999
    .map-container-panel
      position relative
      flex 1
      height 100%
      .map-empty
        position absolute
        top 0
        left 0
        right 0
        width 100%
        height 100%
        background rgba(0, 0, 0, 0.5)
        display flex
        z-index 100
        color #fff
        justify-content center
        align-items center
    #map-container
      flex 1
      width 100%
      height 100%
      .map-marker-current
        left 50%
        top 4.6rem
        position relative
        width 0.5rem
        height 0.5rem
        margin -0.25rem 0 0 -0.25rem
        z-index 10000
      .map-marker-info
        margin 0.1rem
        h2
          font-size 0.2rem
          color #3d69bd
        div
          font-size 0.16rem
          line-height 1.6
          p
            margin 0
          strong
            color #f1543f
            font-weight normal
  .select_area
    height 100vh
    display flex
    justify-content center
    align-items center
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    z-index 10000
    background rgba(0, 0, 0, 0.5)
    .wrap
      background #fff
      border-radius 0.1rem
      width 12rem
      margin 0.25rem auto
      padding 0.35rem
      text-align center
      .ht
        font-size 0.28rem
        padding-bottom 0.2rem
        color #555
      .content
        display flex
        flex-wrap wrap
        a
          width 33.33%
          span
            padding 0.15rem 0
            display block
            font-size 0.2rem
            background #eee
            margin 0 0.1rem 0.1rem 0
  .people-panel
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    z-index 1000
    .people-content
      position absolute
      top 20%
      left 50%
      transform translateX(-50%)
      width 800px
      min-height 530px
      max-height 800px
      overflow-y auto
      overflow hidden
      .people-list
        background #fff
        padding 35px 30px 45px
        .hts
          font-size 20px
          font-weight bold
          margin-bottom 20px
        .p-item-panel
          margin 0 -5px
          display flex
          flex-wrap wrap
          .p-item
            cursor pointer
            font-size 16px
            min-width 80px
            border 1px solid #e6e6e6
            padding 8px 20px
            border-radius 4px
            margin 5px 10px
            text-align center
      .people__close
        position absolute
        top 18px
        right 18px
        cursor pointer
</style>
